'use strict';

module.exports = {
  useDebounce: require('./cache').default,
  useDebouncedCallback: require('./callback').default
};